import { render, staticRenderFns } from "./page-not-found.vue?vue&type=template&id=a36f02ae&"
import script from "./page-not-found.vue?vue&type=script&lang=js&"
export * from "./page-not-found.vue?vue&type=script&lang=js&"
import style0 from "./page-not-found.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/c/Users/tes028/source/Tesfri/logistic-variant-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a36f02ae')) {
      api.createRecord('a36f02ae', component.options)
    } else {
      api.reload('a36f02ae', component.options)
    }
    module.hot.accept("./page-not-found.vue?vue&type=template&id=a36f02ae&", function () {
      api.rerender('a36f02ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/shared/components/page-not-found/page-not-found.vue"
export default component.exports